module.exports = __webpack_public_path__ + "img/puptitle3.af3987a1.png";